<template><BusinessPage module-key="feedbacks" /></template>
<script>import BusinessPage from '../common/BusinessPage.vue'; export default { name: 'FeedbacksPage', components: { BusinessPage } }</script>
